<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5>
                Advertising Orders
            </h5>
        </div>

        <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

        <div v-else class="panel-body">
            <div v-if="orders.data.length">
                <table class="table table-condensed table-striped">
                    <thead>
                    <tr>
                        <th class="col-xs-3">
                            Number
                        </th>

                        <th class="col-xs-3">
                            User
                        </th>

                        <th class="col-xs-10">
                            Title
                        </th>

                        <th class="col-xs-4">
                            Price
                        </th>

                        <th class="col-xs-4">
                            Date
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="order in orders.data">
                        <td>
                            <router-link :to="company.data.id + '/orders/' + order.id">
                                HG{{ order.id }}
                            </router-link>
                        </td>

                        <td>
                            <Avatar
                                v-if="order.attributes.user_initials"
                                :color="order.attributes.user_color"
                            >
                                {{ order.attributes.user_initials }}
                            </Avatar>

                        </td>

                        <td class="ellipsis">
                            <span>
                                {{ order.attributes.title }}
                            </span>
                        </td>

                        <td>
                            {{ order.attributes.price_after_costs | price }}
                        </td>

                        <td>
                            {{ order.attributes.created_at | date }}
                        </td>
                    </tr>

                    <tr v-if="!orders.data.length">
                        <td colspan="4" class="text-center">
                            <i>
                                There are no orders to display.
                            </i>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <pager :pagination="orders.meta" @navigate="page = $event"></pager>
            </div>

            <div v-else class="text-center" style="margin: 50px">
                <i>
                    There are no orders.
                </i>
            </div>
        </div>
    </div>
</template>

<script>
import http from '@/http'
import Avatar from '../../../../../../../components/Avatar'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import Pager from '@/components/Lists/Pager'
import SaveHeight from '@/mixins/SaveHeight'

export default {
    components: {Avatar,LoadingSpinner, Pager},

    mixins: [SaveHeight],

    props: ['company'],

    data() {
        return {
            orders: null,
            page: 1,
            loading: true
        }
    },

    watch: {
        page() {
            this.load()
        }
    },

    mounted() {
        this.load()
    },

    methods: {
        load() {
            this.saveHeight()

            this.loading = true

            http.get('/api/v2/orders', {page_size: 10, page: this.page, 'filter[company_id]': this.company.data.id})
                .then(response => {
                    this.orders = response.data

                    this.loading = false
                })
        }
    }
}
</script>
